<template>
   <div
      class="product-selectors d-flex align-items-center justify-content-center position-relative flex-wrap tour-step"
      :class="{ intro }">
      <product-selector
         v-for="product in visibleProducts"
         :key="product.icon"
         :legacy="legacy"
         :product="product"
         :hidden="false" />
      <product-selector
         v-if="!showAll"
         key="more-toggle"
         :legacy="legacy"
         class="more-toggle"
         @toggle="productsToggled" />
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductSelector from './ProductSelector';

export default {
   name: 'ProductsGrid',
   components: { ProductSelector },
   props: {
      limit: {
         type: Number,
         default: null,
      },
      intro: {
         type: Boolean,
         default: false,
      },
      legacy: {
         type: Boolean,
         default: false,
      },
   },
   computed: {
      visibleProducts() {
         const products = this.products;
         if (this.showAll) {
            return products;
         }
         const visible = products.slice(0, this.limit);
         const { landingpage } = this.$store.state;
         if (landingpage && landingpage.product && visible.indexOf(landingpage.product) === -1) {
            // Add as first, remove last
            visible.unshift(landingpage.product);
            visible.pop();
         }
         return visible;
      },
      hiddenProducts() {
         if (this.showAll) {
            return [];
         }
         return this.products.filter((product) => !this.visibleProducts.find((p) => p === product));
      },
      showAll() {
         return !this.limit || this.showAllProducts || !this.small;
      },
      ...mapGetters(['products', 'width', 'showAllProducts', 'small']),
   },
   methods: {
      productsToggled() {
         this.$nextTick(() => {
            this.$forceUpdate();
         });
      },
   },
};
</script>

<style lang="scss" scoped>
//.product-selectors {
//   display: none !important;
//}
//.product-selectors {
//    margin: -8px;
//    display: flex;
//    justify-content: center;
//    align-items: center;
//    flex-wrap: wrap;
//    position: relative;
//}
</style>
